import React from 'react';
import { GridRenderCellParams } from '@mui/x-data-grid-pro';
import { NxObject } from '@warehouse/object-browser/core';
import DoneIcon from '@mui/icons-material/Done';

export function OnlineCell({ row }: GridRenderCellParams<NxObject, string>) {
	if (row.online === true) return null;
	return <DoneIcon color="error" aria-label="Offline" />;
}
